module.exports = __webpack_public_path__ + "media/images/admin/magazines/icon_leaf2-7fc7e733c37e8da27d62e47aeac92c1f.png";